import React from 'react';
import {Button} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {t} from "i18next";
import { ArrowLeft } from '@phosphor-icons/react';


function GoBack() {
  const navigate = useNavigate();

  return (
    <Button variant="link" className="btn-icon" onClick={ () => navigate(-1) } aria-label={t('back')}>
      <ArrowLeft size={24} />
    </Button>
  );
}

export default GoBack;

